/**
 * WordPress dependencies
 */

import { Path, SVG } from '@wordpress/primitives';

export const bandcamp = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M15.27 17.289 3 17.289 8.73 6.711 21 6.711 15.27 17.289" />
	</SVG>
);
